import React from 'react';
import { Link } from 'react-router-dom';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import classes from '../scss/savedJobs.module.scss';
import { Menu } from '../../../common/Form/Menu/Menu';
import { savedJobOptions } from '../../../../utils/constants';

export const savedJobsConstant = (t, handleJobOptions) => {
  return [
    {
      title: t('dashboard.jobs.appliedlist.id'),
      render: (rowData) => {
        return <Link to={`/dashboard/jobs/${rowData?.JobId}`}>{rowData?.Job?.Id}</Link>;
      }
    },
    {
      title: t('dashboard.jobs.appliedlist.title'),
      render: (rowData) => {
        return rowData?.Job?.JobTitle;
      }
    },
    {
      title: t('dashboard.jobs.appliedlist.type'),
      render: (rowData) => {
        return rowData?.Job?.JobType;
      }
    },
    {
      title: t('dashboard.jobs.appliedlist.industry'),
      render: (rowData) => {
        return rowData?.Job?.Industry;
      }
    },
    {
      title: t('dashboard.jobs.appliedlist.location'),
      render: (rowData) => {
        return rowData?.Job?.Location;
      }
    },
    {
      title: t('dashboard.jobs.appliedlist.status'),
      render: (rowData) => {
        return !rowData?.Job?.IsActive ? (
          <span className={classes.jobStatus}>{t('jobs.status.closed')}</span>
        ) : (
          <span>{t('jobs.status.open')}</span>
        );
      }
    },
    {
      title: '',
      render: (rowData) => {
        return (
          <Menu
            options={savedJobOptions(t, rowData)}
            onMenuSelect={(action) => handleJobOptions(action, rowData?.JobId)}
            isArrowIcon={false}
          >
            <MoreVertIcon />
          </Menu>
        );
      }
    }
  ];
};
